import React from 'react';

export const Inline = ({ underline, className, children }: {
    underline?: boolean;
    className?: string;
    children: React.ReactNode;
}) => {
    return (
        <div
            className={
                'flex w-full gap-5 justify-between' +
                (underline ? ' border-b border-gray-400 pb-4' : '') +
                (className ? ' ' + className : '')
            }>
            {children}
        </div>
    );
};
